/**
 * Stable verification-point colours.
 *
 * Colours identify point ownership, not PASS/FAIL. Verdicts already use
 * green/red, so this palette avoids those semantics. A deterministic hash keeps
 * P01 the same colour across list, viewer markers, recapture and route renders.
 */
export const MARKER_PALETTE = Object.freeze([
  '#2f80ed',
  '#f2994a',
  '#9b51e0',
  '#00a6b2',
  '#d65db1',
  '#d9a404',
  '#5b6dee',
  '#e76f51',
  '#56ccf2',
  '#bb6bd9',
  '#f2c94c',
  '#4d96ff',
  '#c77dff',
  '#ff9f1c',
  '#00b8d9',
  '#b08968',
]);

export function markerColorForPointId(pointId) {
  const text = String(pointId || 'verification-point');
  const sequentialId = text.match(/(?:^|-)(\d+)$/);
  if (sequentialId) {
    const pointNumber = Number(sequentialId[1]);
    if (Number.isSafeInteger(pointNumber) && pointNumber > 0) {
      return MARKER_PALETTE[(pointNumber - 1) % MARKER_PALETTE.length];
    }
  }

  let hash = 0;
  for (let index = 0; index < text.length; index += 1) {
    hash = ((hash << 5) - hash + text.charCodeAt(index)) | 0;
  }
  return MARKER_PALETTE[Math.abs(hash) % MARKER_PALETTE.length];
}
